import React from 'react'

function ViewPosts() {
  return (
    <div>ViewPosts</div>
  )
}

export default ViewPosts